<template>
  <a-modal width="40%" :title="$t('supervise.personalConfig')" v-model="visable" centered @cancel="handleCancel" destroyOnClose :confirmLoading="okLoading">
    <a-card>
        <ul>
          <li>
            <span>{{ $t('global.sxbdkkg') }}:</span> 
            <a-switch style= "margin-left: 10px;"  @change="onClockInChange" v-model="enableClockIn" checked-children="开启" un-checked-children="关闭"/>
          </li>
          <br>  
          <li>
            <span>{{ $t('global.gzms') }}:</span> 
            <a-select style= "margin-left: 10px;"  @change="onWorkModeChange" v-model="workMode" :options="workModeOptions" />
            <template v-if="workMode == '2' || workMode == '3' || workMode == '4'">
              <a-input-number style="margin-left: 10px;" v-model="modeFreq" :min="1"/> 
              <a-select style="margin-left: 10px;" v-model="modeFreqUnit" :options="unitOptions" @change="onBalanceFreqUnitChange"/>
            </template>
             <template v-if="workMode == '5'">
              <a-input-number style="margin-left: 10px;" v-model="modeFreq" :min="300"/> 
               <a-input-number style="margin-left: 10px;" v-model="continuousFreq" :min="1"/> 
              <a-select style="margin-left: 10px;" v-model="modeFreqUnit" :options="unitOptions" @change="onBalanceFreqUnitChange"/>
            </template>
          </li>
           <br> 
          <li>
            <span>{{ $t('global.xmsjd') }}:</span>   
                <a-time-picker   style="margin-left: 10px;"
                v-model="startTime" :placeholder="$t('global.startTimeTip')"
                format="HH:mm" />
                <span class="span">~</span>
                <a-time-picker  
                v-model="endTime" :placeholder="$t('global.endTimeTip')"
                format="HH:mm" /> 
                 <a-select  mode="multiple" style="margin-left: 10px; width: 150px;" v-model="selectedDays" :options="weekDaysOptions"  @change="handleDaysChange" :placeholder="$t('global.xzrq')"/>
                <a-select style="margin-left: 10px;" v-model="sleepMode" :options="sleepModes" />
          </li>
          <br> 
          <li>
            <span>{{ $t('global.qxhm') }}:</span>  
            <a-input style="margin-left: 10px; width: 150px;" v-model="familyPhoneOne" placeholder="请输入亲情号码1" allowClear/>
            <a-input style="margin-left: 10px; width: 150px;" v-model="familyPhoneTwo" placeholder="请输入亲情号码2" allowClear/>
          </li> 
        </ul>
    </a-card>
    <template slot="footer">
       <a-button type="danger" @click="rebootDevice" :loading="rebootLoading">一键重启</a-button>
      <a-button @click="handleCancel">取消</a-button>
      <a-button type="primary" @click="handleOk" :loading="okLoading">确认</a-button>
    </template>
  </a-modal>
</template>
<script>
  import config from '../../config/'
  import moment from 'moment'
  export default {
    data() {
      return { 
        // 确定按钮加载状态
        okLoading: false, 
        rebootLoading: false,
        // 用户配置属性 
        personId: '',
        visable: false,
        initData: '',
        groupConfig: '',
        personalConfig: '',  
        addTimeFlag:true,
        enableClockIn:false,
        workMode: '4', 
        continuousFreq: 15, 
        modeFreq: 1,
        modeFreqUnit: 'S',
        startTime: null,
        endTime: null, 
        familyPhoneOne:'',
        familyPhoneTwo:'',
        weekDaysOptions: [
          {"key":'1','label':'周一'},
          {"key":'2','label':'周二'},
          {"key":'3','label':'周三'},
          {"key":'4','label':'周四'},
          {"key":'5','label':'周五'},
          {"key":'6','label':'周六'},
          {"key":'7','label':'周日'},
        ],
        selectedDays: [],
        sleepModes:[
            {"key":'0','label':'普通休眠'},
            {"key":'1','label':'深度休眠'},
        ],
        sleepMode: '0',
         
      }
    },
    computed: {
      freqOptions () {
        let freq = []
        for(let i=1;i<60;i++){
          freq.push({"key":i*60,"label":i + this.$t('global.minute')},)
        }
        for(let i=1;i<=24;i++){
          freq.push({"key":i*60*60,"label":i + this.$t('global.hour')},)
        }
        return freq
      },
      workModeOptions () {
        return [
          {"key":'1','label':this.$t('global.powerSaveMode')},
          {"key":'2','label':this.$t('global.balanceMode')},
          {"key":'3','label':this.$t('global.realTimeMode')},
          {"key":'4','label':this.$t('global.shakeUploadMode')},
          {"key":'5','label':this.$t('global.continuousLocateMode')},
        ]
      },
      unitOptions () {
        return [
          {"key":'H','label':this.$t('global.hour')},
          {"key":'M','label':this.$t('global.minute')},
          {"key":'S','label':this.$t('global.second')},
        ]
      },
    },
    methods: {
      handleDaysChange(value) {
        console.log(`selectedDays ${value}`);
      },
      rebootDevice () {
        this.$confirm({
          title: '确认重启',
          content: '确定要重启该设备吗？',
          onOk: () => {
            this.rebootLoading = true
            // 构建重启请求参数
            let rebootConfig = {
              entityId: this.personId, 
              type: 'reset',
            }  
            this.$http.post(config.api.send_command, rebootConfig).then((res) => {
              this.rebootLoading = false
              if (res.code === 0) {
                this.$notification.success({
                  message: '重启命令已发送'
                })
                this.visable = false
              } else {
                this.$notification.error({
                  message: `${res.desc}`
                })
              }
            })
          }
        })
      },
      onBalanceFreqUnitChange(value) {
        console.log(`balanceFreqUnit ${value}`); 
      },
      onWorkModeChange(value) {
        console.log(`workMode ${value}`);
      },
      onClockInChange(checked) {
        console.log(`enableClockIn ${checked}`);
        this.enableClockIn = checked
      },
       
      // 修改个人配置参数
      modifiedPersonalConfig() {
        this.okLoading = true
        let newConfig = {  
          id: this.personId,
          oui:'AY',
          enableClockIn: this.enableClockIn,
          work: {
            mode: this.workMode,
            ...(this.workMode !== '1' ? { generalFreq: this.modeFreq } : {}),
            ...(this.workMode !== '1' ? { unit: this.modeFreqUnit } : {}),
            ...(this.workMode === '5' ? { continuousFreq: this.continuousFreq } : {})
          }, 
          sleep: {
            startTime: this.startTime ? this.formatTimeToHHmm(this.startTime) : null,
            endTime: this.endTime ? this.formatTimeToHHmm(this.endTime) : null,
            days: this.selectedDays,
            mode: this.sleepMode,
          },
          familyPhones: [this.familyPhoneOne, this.familyPhoneTwo].filter(phone => phone && phone.trim() !== ''), 
        }
        console.log(newConfig);
        
        this.$http.put(config.api.put_personnal_config, newConfig).then((res) => {
          this.okLoading = false
          if (res.code === 0) {
            this.$notification.success({
              message: this.$t('global.commitSuccess')
            })
            this.visable = false
          } else {
            this.$notification.error({
              message: `${res.desc}`
            })
          }
        })
      },
      handleOk() {
        // console.log('ok')
        this.modifiedPersonalConfig()
      },
      
      // 重置表单到初始状态
      resetForm() {
        this.getPersonalConfig(this.personId)
      },
      handleCancel() {
        this.visable = false
        this.okLoading = false
      },
      showModal(options) {
        console.log(options)
        this.visable = true
        this.initData = options
        this.personId = options.id
        this.getPersonalConfig(this.personId) 
      },
      // 获取个人监管配置 
      formatTimeToHHmm(time) {
        if (!time) return null;
        if (typeof time === 'string' && /^\d{2}:\d{2}$/.test(time)) {
          return time;
        }
        // 处理 moment 对象
        if (time && moment.isMoment(time)) {
          return time.format('HH:mm');
        }
        let date = time;
        if (typeof time === 'number' || typeof time === 'string') {
          date = new Date(time);
        }
        if (date instanceof Date && !isNaN(date.getTime())) {
          const hours = String(date.getHours()).padStart(2, '0');
          const minutes = String(date.getMinutes()).padStart(2, '0');
          return `${hours}:${minutes}`;
        }
        return null; 
      },
      
      // 获取个人监管配置
      getPersonalConfig(personId) {
        return new Promise((resolve) => {
          this.$http.get(config.api.get_personnal_config + personId).then((res) => {
            console.log(res)
            let {
              code,
              desc,
              result
            } = res
            if (code === 0 && desc === 'success' && result) {
              let pc = result.personalConfigModel
              this.enableClockIn = pc.enableClockIn;
              let sleepT = pc.sleep;
              this.selectedDays = sleepT.days; 
              this.startTime = sleepT.startTime ? moment(sleepT.startTime, 'HH:mm') : null;
              this.endTime = sleepT.endTime ? moment(sleepT.endTime, 'HH:mm') : null;

              let workT = pc.work;
              this.modeFreq = workT.generalFreq;
              this.modeFreqUnit = workT.unit;
              this.continuousFreq = workT.continuousFreq;

              let familyPhones = pc.familyPhones.filter(phone => phone && phone.trim() !== '');
              if (familyPhones.length == 1) {
                  this.familyPhoneOne = familyPhones[0];
              }
              if (familyPhones.length == 2) {
                  this.familyPhoneOne = familyPhones[0];
                  this.familyPhoneTwo = familyPhones[1];
              }
            }
          })
        })
      },
    }
       
  }
</script>
<style lang="less" scoped>
@import '../../theme/color.less';
ul{
  li{
    span{
      font-size: 16px;
      font-weight: bold;
    }
  }
}
.lists {
  .list {
    margin: 10px 0 10px 0;
    display: flex;
    .span {
      margin: 0 10px;
    }
    .deleteBtn {
      margin: 0 10px;
      color: rgb(209, 21, 21);
    }
  }
}
</style>
